export default {
    useWindowListeners: true
};
